import { render, staticRenderFns } from "./WorkExpansionPanelHeader.vue?vue&type=template&id=d4c32b4e&scoped=true"
import script from "./WorkExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./WorkExpansionPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./WorkExpansionPanelHeader.vue?vue&type=style&index=0&id=d4c32b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c32b4e",
  null
  
)

export default component.exports